import { Point } from 'src/modules/common/types/Point';
import { HvacAnnotation } from 'src/modules/hvac/types/HvacAnnotation';

export const HVAC_SCHEMA_SIZE: Point = {
  x: 684,
  y: 480,
};

export const HVAC_SCHEMA_ANNOTATION_EMISSION: ReadonlyArray<HvacAnnotation> = [
  {
    key: 'general-emission-room',
    point: {
      x: 342,
      y: 340,
    },
    files: new Set([
      'E_GENERAL_EmissionRoom',
      'E_GENERAL_EmissionTABSRoom',
    ]),
  },
  {
    key: 'general-room-unit',
    point: {
      x: 400,
      y: 420,
    },
    files: new Set([
      'E_GENERAL_RoomUnit',
      'E_GENERAL_RoomUnit_T',
      'E_GENERAL_RoomUnit_T_CO2',
      'E_GENERAL_RoomUnit_T_CO2_VOC',
    ]),
  },
  {
    key: 'cooling-valve-room',
    point: {
      x: 219,
      y: 290,
    },
    files: new Set([
      'E_COOLING_ValveRoom',
      'E_COOLING_ValveRoom_Thermostatic',
    ]),
  },
  {
    key: 'heating-valve-room',
    point: {
      x: 463,
      y: 290,
    },
    files: new Set([
      'E_HEATING_ValveRoom',
      'E_HEATING_ValveRoom_Thermostatic',
    ]),
  },
  {
    key: 'heating-valve-distr',
    point: {
      x: 652,
      y: 350,
    },
    files: new Set([
      'E_HEATING_ValveDistr',
    ]),
  },
  {
    key: 'cooling-valve-distr',
    point: {
      x: 32,
      y: 350,
    },
    files: new Set([
      'E_COOLING_ValveDistr',
    ]),
  },
];

export const HVAC_SCHEMA_ANNOTATION_DISTRIBUTION: ReadonlyArray<HvacAnnotation> = [];

export const HVAC_SCHEMA_ANNOTATION_AIR_HANDLER: ReadonlyArray<HvacAnnotation> = [];

export const HVAC_SCHEMA_ANNOTATION_GENERATION: ReadonlyArray<HvacAnnotation> = [];
